import {
  compactFormat,
  dimension,
  dimensionSelector,
  legendPosition,
  palette,
  primaryMetric,
  primaryMetricSelector,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

const mapSettings = {
  palette,
  legendPosition: { ...legendPosition, gridPosition: [3, 0] },
  compactFormat: { ...compactFormat, gridPosition: [4, 0] },

  decompositionMetric: {
    default: "state",
    type: "select",
    label: "Decomposition Metric 1",
    dictionary: "mapGeographyTypes",
    apiParameter: "dimension",
    gridPosition: [0, 0],
    tooltipOrder: 0,
  },
  decompositionMetricTitle: {
    default: "",
    type: "text",
    label: "Decomposition Metric 1 Axis Title",
    gridPosition: [0, 1],
    forAxis: "decompositionMetric",
  },
  displayMetric: {
    default: "advertiser_total_purchase",
    type: "select",
    label: "Display Metric",
    dictionary: "advertisersMetrics",
    gridPosition: [2, 0],
    tooltipOrder: 1,
  },
  minValueColor: {
    default: "#4E5068",
    type: "color",
    label: "Min Value Color",
    dictionary: "colors",
    gridPosition: [3, 1],
  },
  maxValueColor: {
    default: "#F362E7",
    type: "color",
    label: "Max Value Color",
    dictionary: "colors",
    gridPosition: [4, 1],
  },
  dimensionSelector: { ...dimensionSelector, gridPosition: [5, 0] },
  primaryMetricSelector: { ...primaryMetricSelector, gridPosition: [6, 0] },
};

export default <Config>{
  family: [FAMILY.DECOMPOSITION],
  draft: [],
  title: "Map Chart",
  defaultHeight: 6,
  dataModes: ["explore"],
  controls: [
    { ...dimension, dictionary: "mapGeographyTypes" },
    { ...primaryMetric, dictionary: "advertisersMetrics" },
  ],
  settings: mapSettings,
  planSettings: {},
  planExploreSettings: mapSettings,
};
